import React, { Component } from "react";
import ReactDOM from 'react-dom';
import DayPicker from 'react-day-picker';

import Variables from "../../Utils/Variables";
import Registry from "../../Utils/Registry";
import Helpers from "../../Utils/Helpers";
import RangeSlider from "../RangeSlider";

let scrollIntoView = require('scroll-into-view');


class CreateOrderCalendar extends Component{
    constructor(props){
        super(props);

        this.api = Registry.registered("api");

        this.dayChoosen = this.dayChoosen.bind(this);
        this.toggleCalendar = this.toggleCalendar.bind(this);
        this.handleDocClick = this.handleDocClick.bind(this);

        if(this.props.state)
            this.state = this.props.state;
        else{
            this.state = {
                loading: false,
                value: "",
                showCalendar: this.props.isOpen,
                chosenSlot: false,
                slots: [],
                selected_day: []
            }
        }
    }

    componentWillMount() {
        document.addEventListener('click', this.handleDocClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDocClick, false);
    }

    handleDocClick(e){
        if(!ReactDOM.findDOMNode(this).contains(e.target)) {
            if(this.state.showCalendar)
                this.setState({showCalendar: false});
        }
    }

    dayChoosen(date){
        let currentDate = new Date();
        
		this.setState({
            selected_day: [date],
			value: Helpers.formatDate(date, "dddd DD MMMM")
        }, () => {
            this.toggleCalendar();
            this.props.onDateChosen(this.state.selected_day[0], this.state);
        });
    }

    toggleCalendar(){
        this.setState({showCalendar: !this.state.showCalendar}, () => {
            if(this.state.showCalendar)
                scrollIntoView(this.refs.calendar);
        });
    }

    render(){
        return (
            <div className="relative ty-calandar">
                <div className="ty-input-div blue_dark pointer" ref="input" onClick={this.toggleCalendar}>
                    {
                        this.state.value ?
                            this.state.value
                            :
                            <div className="gray_dark">{this.props.placeholder}</div>
                    }
                </div>
                {
                    this.state.showCalendar ?
                        <div ref="calendar" className="ty-calendar absolute top-40 wp-100 bg-white">
                            <DayPicker
                                onDayClick={this.dayChoosen}
                                selectedDays={this.state.selected_day}
                                locale="fr"
                                months={Variables.months}
                                weekdaysLong={Variables.weekdays_long}
                                weekdaysShort={Variables.weekdays_short}
                                firstDayOfWeek={1}
                                disabledDays={[
                                    {daysOfWeek: [0, 6]},
                                    {before: new Date()}
                                ]}
                            />
                        </div>
                        :
                        ""
                }
            </div>
        );
    }
}

CreateOrderCalendar.defaultProps = {
    placeholder: "Choisir une date ...",
    value: "",
    location: "",
    isOpen: false,
    state: {},
    //onSlotChosen: (date, min, max, state) => {},
    onDateChosen: date => {}
};

export default CreateOrderCalendar;



// WEBPACK FOOTER //
// ./src/components/CreateOrder/Calendar.js